import { convertUnit } from '../../../functions/prefixed-unit/convert-unit';
import { WeightMetric } from '../../../model/prefixed-unit/weight.metric';
import { ClientBoardContainer } from '../../../public/dashboard/shared/model/client-board-container';

export function convertValuesToGrams(
  values: Array<number | undefined>,
  board: ClientBoardContainer
): Array<number | undefined> {
  return values.map((v) => convertValueToGrams(v, board));
}

export function convertValueToGrams(value: number | undefined, board: ClientBoardContainer): number | undefined {
  if (value !== undefined) {
    value = convertUnit(board.boardSettings.displayUnit, WeightMetric.Gram, value);
  }
  return value;
}
